import { ConfirmedHarmonisedStandardsStep } from '@/v2/components/product-compliance-briefing/ConfirmedHarmonisedStandardsStep'
import type { ConfirmedHarmonisedStandard } from '@/v2/lib/confirmedHarmonisedStandards'
import type { EmcBriefingStep } from '../../utils/emcLegislationBriefing'
import { V2EmcLegislationBriefingStepShell } from './V2EmcLegislationBriefingStepShell'

export function V2EmcConfirmedStandardsStep({
  step,
  index,
  standards,
  canWrite,
  onEditStandards,
}: {
  step: EmcBriefingStep
  index: number
  standards: ConfirmedHarmonisedStandard[]
  canWrite: boolean
  onEditStandards: () => void
}) {
  return (
    <ConfirmedHarmonisedStandardsStep
      standards={standards}
      canWrite={canWrite}
      onEditStandards={onEditStandards}
      i18nKeyPrefix='v2.pages.products.detail.emcBriefing.confirmedStandards'
      stepShell={({ actions, children }) => (
        <V2EmcLegislationBriefingStepShell
          step={step}
          index={index}
          actions={actions}
        >
          {children}
        </V2EmcLegislationBriefingStepShell>
      )}
    />
  )
}
